<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M555 1143 c-93 -49 -114 -98 -115 -267 0 -148 11 -195 57 -244 19
-20 33 -45 33 -59 0 -48 -15 -59 -105 -78 -160 -34 -187 -73 -183 -262 l3
-118 395 0 395 0 3 125 c4 184 -21 220 -174 254 -43 9 -84 22 -91 28 -21 17
-16 82 8 104 47 42 59 89 59 242 0 121 -3 148 -19 180 -23 45 -66 87 -104 101
-41 16 -127 13 -162 -6z m171 -154 c10 -12 31 -27 46 -35 27 -14 28 -17 28
-94 l0 -79 -77 36 c-85 39 -76 39 -185 -11 l-58 -26 0 79 0 78 49 7 c26 3 72
19 102 35 67 35 72 36 95 10z m-6 -215 c44 -20 80 -39 80 -41 0 -15 -34 -65
-60 -86 -78 -66 -206 -36 -246 58 l-13 30 77 37 c42 20 78 37 80 37 1 1 39
-15 82 -35z m0 -230 c0 -17 7 -37 15 -44 20 -16 20 -16 -43 -74 l-53 -50 -54
54 -54 53 20 25 c10 14 19 34 19 46 0 20 5 21 75 21 l75 0 0 -31z m161 -203
c16 -2 19 -38 9 -88 -12 -58 -24 -66 -42 -28 -6 14 -15 25 -19 25 -5 0 -11
-11 -15 -25 -6 -25 -34 -35 -34 -12 -1 6 -5 31 -9 54 -13 69 16 89 110 74z"
      />
      <path
        d="M162 1060 c-34 -21 -62 -71 -62 -111 0 -11 8 -37 17 -56 50 -107 206
-91 244 24 9 28 8 43 -6 78 -29 79 -121 109 -193 65z"
      />
      <path
        d="M955 1041 c-72 -33 -97 -120 -55 -189 21 -34 71 -62 111 -62 36 0 90
32 110 64 67 111 -49 242 -166 187z"
      />
      <path
        d="M1164 928 c8 -18 17 -57 21 -85 l7 -53 39 0 c35 0 39 3 39 25 0 40
-24 89 -59 118 -46 39 -64 37 -47 -5z"
      />
      <path
        d="M105 752 c-73 -46 -94 -99 -95 -234 0 -116 9 -143 55 -165 36 -17 36
-18 50 -125 5 -35 13 -53 32 -68 14 -11 29 -20 33 -20 4 0 5 25 2 55 -4 50 -3
55 16 55 18 0 20 8 23 78 6 112 41 153 159 183 l65 17 3 58 c2 46 -3 67 -20
98 -41 70 -65 81 -186 84 -91 2 -111 0 -137 -16z"
      />
      <path
        d="M925 736 c-16 -7 -37 -22 -47 -32 -16 -18 -58 -134 -58 -160 0 -7 24
-18 58 -25 152 -33 183 -73 191 -257 6 -119 7 -123 25 -109 13 10 22 31 25 63
l6 48 73 19 c39 11 72 24 72 30 0 19 -101 341 -116 370 -30 56 -155 86 -229
53z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
